export enum WizardItemRuleType {
	MIN_LENGTH = 'minLength',
	MAX_LENGTH = 'maxLength',
	MAX = 'max',
	MIN = 'min',
	AGE_MIN = 'ageMin',
	AGE_MAX = 'ageMax',
	MAX_DATE = 'maxDate',
	MIN_DATE = 'minDate',
	EMAIL = 'email',
}
